export default __webpack_public_path__ + "static/media/scapy.15ff9c3a.png";